/* ---------------------------------------------------------------------------
 * Copyright (c) 2020 - Watt-IS
 *
 * Project:    deco
 * File:       app/javascript/lib/Buttons.jsx
 * Creator:    Pedro Major <pedro.major@gmail.com>
 * Created:    2020-05-26
 * ------------------------------------------------------------------------ */

import React from "react";
import PropTypes from "prop-types";
import Ok from "~/images/check.svg?react";
import Cancel from "~/images/close.svg?react";

const FormButton = ({
  label,
  Icon,
  iconStyle = "fill-current h-5",
  className,
  onClick,
  disabled = false,
}) => (
  <button
    className={`${className} ml-2 flex justify-between items-center  \
                 font-bold text-white rounded-full \
               btn ${disabled ? "opacity-50 cursor-not-allowed" : ""}`}
    onClick={onClick}
    disabled={disabled}
  >
    <div>{label}</div>
    {Icon && <Icon className={iconStyle} />}
  </button>
);

const OkButton = (
  { onClick, label = "Aceitar", className = "" }
) => (
  <FormButton
    className={`bg-btn-tertiary flex justify-between items-center px-5 py-3 text-base gap-2 font-semibold text-white rounded-full btn ${className}`}
    label={label}
    onClick={onClick}
  />
);

const CancelButton = (
  { onClick, label = "Cancelar", className = "" }
) => (
  <FormButton
    className={`bg-orange-fanta flex justify-between items-center px-5 py-3 text-base gap-2 font-semibold text-white rounded-full btn ${className}`}
    label={label}
    onClick={onClick}
  />
);

const CustomButton = ({
  onClick,
  label = "Custom",
  styleClass = "",
  icon,
  iconStyle,
  disabled = false,
}) => (
  <FormButton
    className={`${styleClass} flex justify-between items-center gap-2 font-normal btn`}
    label={label}
    onClick={onClick}
    Icon={icon}
    iconStyle={iconStyle}
    disabled={disabled}
  />
);

const OkCancelRow = ({ className, onOk, onCancel, okLabel, cancelLabel }) => (
  <div
    className={`flex flex-wrap gap-y-4 items-center text-white ${className}`}
  >
    <CancelButton
      onClick={onCancel}
      label={cancelLabel}
    />
    <OkButton
      onClick={onOk}
      label={okLabel}
    />
  </div>
);

const CircleButton = ({ className, iconClassName, onClick, w, h, iconUri }) => (
  <button
    className={`btn relative ${w} ${h} ${className}`}
    onClick={onClick}
  >
    <div
      className="absolute inset-0 rounded-full \
                opacity-0 hover:opacity-20 bg-primary"
    ></div>

    <img
      className={`object-cover rounded-full \
      ${iconClassName}`}
      src={iconUri}
    ></img>
  </button>
);

CircleButton.defaultProps = {
  w: "w-auto",
  h: "h-auto",
};

CircleButton.props = {
  className: PropTypes.string,
  iconClassName: PropTypes.string,
  w: PropTypes.string,
  h: PropTypes.string,
  uri: PropTypes.string,
  onClick: PropTypes.func,
};

export { OkButton, CancelButton, OkCancelRow, CustomButton, CircleButton };
